import * as React from 'react';
import { Route } from 'react-router';
import URLHelpers from '../components/shared/url_helpers';

const OnboardingRoute = (
  <Route
    key={URLHelpers.onboardingPath}
    path={URLHelpers.onboardingPath}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../onboarding/progressive_onboarding_container').default);
        },
        'onboarding',
      );
    }}
  />
);

const OnboardingCompleteRoute = (
  <Route
    key={URLHelpers.onboardingCompleteShopDetailsPath}
    path={URLHelpers.onboardingCompleteShopDetailsPath}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../onboarding/progressive_onboarding_container').default);
        },
        'onboarding',
      );
    }}
  />
);

const OnboardingBegin3DS1Route = (
  <Route
    key={URLHelpers.onboardingBegin3DS1}
    path={URLHelpers.onboardingBegin3DS1}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../onboarding/progressive_onboarding_container').default);
        },
        'onboarding',
      );
    }}
  />
);

const OnboardingRoutes = [
  OnboardingRoute,
  OnboardingCompleteRoute,
  OnboardingBegin3DS1Route,
];

export default OnboardingRoutes;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/routes/progressive_onboarding.jsx